import { useState } from "react";
import {
  COOKIE_NAME,
  COOKIE_QUERY_NAME,
  deleteCookie,
  gtmRegistration,
  validatePassword,
  POST_REG_FUNNEL_SHOW,
  POST_REG_FUNNEL_SHOW_REQUIRED,
  prepareRegistrationData,
  REGISTRATION_CONFIRMED,
} from "../../helpers";
import { landingId } from "../../constants";
import { apiRegistration } from "../../services/api";
import Eye from "../../images/eye.svg";
import EyeOff from "../../images/eye-off.svg";
import { ButtonSubmit } from "../ButtonSubmit";
import { InputGlobal } from "../InputGlobal";
import { useAppendLandingId } from "../../hooks/useAppendLandingId";
import "./Password.scss";

export const Password = ({ data, setData, nextStep }) => {
  const [errorPassword, setErrorPassword] = useState(null);
  const [passwordShow, setPasswordShow] = useState(false);
  const [responseError, setResponseError] = useState(null);
  const [checkBox, setCheckBox] = useState(false);
  const [termsError, setTermsError] = useState(null);
  const [loader, setLoader] = useState(false);

  useAppendLandingId(landingId);

  const handlerSubmit = (e) => {
    e.preventDefault();
    setResponseError(null);

    const { status, error } = validatePassword(data.password);
    if (!status) {
      setErrorPassword(error);
    } else if (!checkBox) {
      setTermsError("Before register you must agree with our Terms of Use.");
    } else {
      setLoader(true);
      apiRegistration(prepareRegistrationData(data), responseCb);
    }
  };

  const toggleBtn = (e) => {
    e.preventDefault();
    setPasswordShow(!passwordShow);
  };

  const responseCb = (response) => {
    setLoader(false);
    if (response.status === 200) {
      const data = JSON.parse(response.responseText);

      if (data.success === true) {
        deleteCookie(COOKIE_QUERY_NAME);
        deleteCookie(COOKIE_NAME);

        gtmRegistration(data.data);

        if (data.data.onModeration === true) {
          window.location.href = "/moderation/";
        } else {
          if (
            data.data.confirmed == REGISTRATION_CONFIRMED &&
            data.data.access_token
          ) {
            if (
              data.data.reg_funnel_status == POST_REG_FUNNEL_SHOW ||
              data.data.reg_funnel_status == POST_REG_FUNNEL_SHOW_REQUIRED
            ) {
              window.location.href = "/wizard/";
            } else {
              window.location.href = "/app/";
            }
          } else {
            window.location.href = "/confirm/";
          }
        }
      }

      return;
    } else if (response.status === 422) {
      const data = JSON.parse(response.responseText);

      if (data.errors && data.errors.length > 0) {
        let errorText = "";

        for (let i = 0; i < data.errors.length; i++) {
          const error = data.errors[i];

          errorText += i > 0 ? " " + error.message : error.message;
        }

        setResponseError(errorText);
        return;
      }
    } else if (response.status === 403) {
      window.location.href = "/moderation/";
      return;
    }

    setResponseError(
      "Can't register your profile now. Please try again later."
    );
  };

  const handlerAddPasword = (e) => {
    e.preventDefault();
    setErrorPassword(null);
    setData({ ...data, password: e.target.value });
  };

  const handleCheckBox = (e) => {
    setTermsError(false);
    setCheckBox(!checkBox);
  };

  return (
    <>
      {loader && (
        <div className="spin-loader">
          <span>Loading...</span>
        </div>
      )}
      <div className="global__wrapper password">
        <form className="form__global" onSubmit={handlerSubmit}>
          <h3 className="title__global password">Create your password </h3>
          <p className="password__text">
            and enjoy communication with amazing people 💕
          </p>
          <div className="password__wrapper">
            <div className="has-float-label">
              <InputGlobal
                className={"input__global" + (errorPassword ? " error" : "")}
                onChange={(e) => handlerAddPasword(e)}
                name={"password"}
                placeholder={"Your password"}
                type={passwordShow ? "text" : "password"}
                id={"password"}
              />
              <label
                htmlFor="password"
                className={errorPassword ? "error" : ""}
              >
                Your password
              </label>
            </div>
            <button onClick={toggleBtn} className="logo__eye">
              {passwordShow ? (
                <img src={Eye} alt="icon" />
              ) : (
                <img src={EyeOff} alt="icon" />
              )}
            </button>
            {errorPassword && <p className="error-text">{errorPassword}</p>}
          </div>

          <div className="terms__wrapper">
            <input
              checked={checkBox}
              onChange={(e) => handleCheckBox(e)}
              type="checkbox"
              id="remember_me"
              className={"checkBox" + (termsError ? " error" : "")}
              name="remember"
              value="1"
            />
            <label htmlFor="remember_me">
              <span>
                <span> I have read, understand and agree to </span>
                <span>
                  <a href="/terms-of-use/" target="_blank">
                    Terms of Use,&nbsp;
                  </a>
                </span>
                <span>
                  <a href="/privacy-policy/" target="_blank">
                    Privacy Policy,&nbsp;
                  </a>
                </span>
                <span>
                  <a href="/cookie-policy/" target="_blank">
                    Cookie policy
                  </a>
                </span>
              </span>
            </label>
            {termsError && <p className="error-text">{termsError}</p>}
            {responseError && <p className="error-text">{responseError}</p>}
          </div>

          <ButtonSubmit className={"button last"} text={"Join Now"} />
        </form>
      </div>
    </>
  );
};
